import React from 'react';



const Liked = (props)=>{
    const { divStyle, likedStyle,buttonStyle } = styles;
    const {currentName } = props;
    return(
        <div style={divStyle} >
           <p style={buttonStyle}>{currentName.likes} Likes<i className="fas fa-check-circle" style={likedStyle}></i>
           </p>
        </div>
    )
}


const styles={
    divStyle:{
        flex: 1
    },
    likedStyle:{
        fontSize: "12px",
        color: "white",
        float: "right",
        marginTop: "4px",
        marginRight: "auto",
        paddingLeft: "none",
    
    },
    buttonStyle:{
        border: '1px solid dodgerblue',
        padding: "0.4em 1.5em",
        width: "130px",
        borderRadius: "5px",
        backgroundColor: "dodgerblue",
        outline: "none",
        color: "white",
        cursor: 'pointer'

        },
}
export default Liked;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/liked.js